
import { AnsweringClient } from "../../clients/answeringClient";

export interface ArchiveGroupModalControllerDelegate {
  didArchiveGroup: () => void;
  groupShouldLogout: () => void;
  genericError: () => void;
}

export class ArchiveGroupModalController {

  constructor (
    private delegate: ArchiveGroupModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async archiveGroup(accessToken: string, groupId: string) {
    try {
      await this.answeringClient.archiveGroup(accessToken, groupId);
      this.delegate.didArchiveGroup();
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.archiveGroup(newTokens.accessToken, groupId);
        return;
      }
      this.delegate.genericError();
    }
  }

  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.groupShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.groupShouldLogout();
      return;
    }
  }
}
